import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CommonHeaderRoutingModule } from './common-header-routing.module';
import { CommonHeaderComponent } from './common-header.component';
import { RouterModule } from '@angular/router';
import { HgCommonModule } from '../hg-common/hg-common.module';

@NgModule({
  imports: [
    CommonModule,
    CommonHeaderRoutingModule,
    RouterModule,
    HgCommonModule
  ],
  exports: [CommonHeaderComponent],
  declarations: [CommonHeaderComponent]
})
export class CommonHeaderModule { }
